import React from "react";
import NumberFormat from "react-number-format";
import NullableValue from "../../../../../../../../Utils/renderField/nullableValue";
import { RenderNumber } from "../../../../../../../../Utils/renderField/renderReadField";
import { formatPalletLabel } from "../../../../../../helpers/formatPallet";

export const ReclasificacionesTable = ({
    inventariosReclasificacion,
    handleChange,
}) => {
    return (
        <div className="new-table-wrapper mt-3">
            <table className="table-striped">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Origen</th>
                        <th>Pacas disponibles</th>
                        <th>Cant. a tomar</th>
                    </tr>
                </thead>
                <tbody>
                    {inventariosReclasificacion.length === 0 && (
                        <tr>
                            <td colSpan={4} className="text-center">
                                No hay inventarios reclasificacion cargados
                            </td>
                        </tr>
                    )}
                    {inventariosReclasificacion.map((inventario) => (
                        <tr key={inventario.id}>
                            <td className="text-center text-nowrap">
                                <NullableValue value={inventario.id}>
                                    {inventario.id}
                                </NullableValue>
                            </td>
                            <td className="text-center text-nowrap">
                                <NullableValue value={inventario.pallet}>
                                    {inventario.pallet &&
                                        `Pallet ${formatPalletLabel(
                                            inventario.pallet.numero,
                                            inventario.pallet
                                                .identificador_fisico,
                                        )}`}
                                </NullableValue>
                            </td>
                            <td className="text-center text-nowrap">
                                <NullableValue
                                    value={inventario.pacas_disponibles}
                                >
                                    <RenderNumber
                                        value={inventario.pacas_disponibles}
                                        decimalScale={0}
                                    />
                                </NullableValue>
                            </td>
                            <td className="text-center">
                                <div
                                    className="mx-auto"
                                    style={{ maxWidth: "120px" }}
                                >
                                    <NumberFormat
                                        className="form-control"
                                        value={inventario.pacas_a_consumir}
                                        thousandSeparator=","
                                        allowNegative={false}
                                        isAllowed={(values) => {
                                            const { floatValue } = values;

                                            if (floatValue === undefined) {
                                                return true;
                                            }

                                            return (
                                                floatValue <=
                                                    inventario.pacas_disponibles &&
                                                floatValue >= 0
                                            );
                                        }}
                                        onValueChange={(values) => {
                                            handleChange(
                                                inventario.id,
                                                "pacas_a_consumir",
                                                values.floatValue,
                                            );
                                        }}
                                        placeholder="0"
                                        decimalScale={0}
                                    />
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};
